import "./App.css";
import PageRouter from "./router";

function App() {
  return (
    <div className="App">
      <PageRouter />
    </div>
  );
}

export default App;
